module.exports = __webpack_public_path__ + "img/christof_rupp.9abd2535.png";